<template>
    <PageFrameContainer>

        <h2>
            Pay Pal Payment
        </h2>

    </PageFrameContainer>
</template>

<script>
    import PageFrameContainer from "../../../components/PageFrameContainer";

    export default {
        name: "PayPalPage",
        components: {PageFrameContainer},
        props: {},
        data: function () {
            return {}
        },
        computed: {
            cart() {
                return this.$store.state.cart;
            }
        },
        mounted: function () {


        },
        methods: {}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    h2 {
        font-weight: 300;
        font-size: 2em;
        color: $primary20;
    }

</style>